import Button from 'components/shared/Button/Button';

const ExportButton = ({ open, customLabel }) => {
  const color = open ? 'primary' : 'neutral';
  return (
    <Button
      size="xs"
      color={color}
      variant="tertiary"
      text={customLabel}
      icon="export-mono"
      textClassName={`text-${color}-700`}
      outlined
    />
  );
};

export default ExportButton;
